import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import './css/ModernAuditionCard.css';

const ModernAuditionCard = ({ audition }) => {
  if (!audition) return null;

  // Map keys from your new JSON response
  const id = audition.id || audition.jogetRoleId;
  // const jogetRoleId = audition.jogetRoleId || audition.id;
  const urlSlug = audition.urlSlug || '';
  const projectName = audition.projectName || 'Untitled Project';
  const roleTitle = audition.roleTitle || 'Untitled Role';
  const roleCategory = audition.roleCategory || 'Talent Required';
  
  // Use the full URL provided by the backend (includes the SVG placeholder)
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(projectName)}&background=050506&color=fff&size=20`;
  const displayImage = audition.projectImageUrl || defaultAvatar;

  const formatType = (text) => {
    if (!text || text === 'N/A') return 'Audition';
    return text.replace(/([A-Z])/g, ' $1').trim();
  };

  const auditionTypes = audition.auditionType && audition.auditionType !== 'N/A'
    ? audition.auditionType.split(';').map((t) => formatType(t))
    : ['Audition'];

  return (
    <Link to={`/audition/${id}/${urlSlug}`} className="audition-card-link">
      <Card className="bms-audition-card">
        <div className="bms-image-wrapper">
          <img
            src={displayImage}
            alt={projectName}
            className="bms-card-image"
            onError={(e) => {
              e.target.src = defaultAvatar;
            }}
          />

          <div className="bms-top-row">
            <div className="bms-top-badges">
              {auditionTypes.map((type, index) => (
                <span key={index} className="bms-badge-top text-uppercase">
                  {type}
                </span>
              ))}
            </div>
            <span className="bms-category-badge-mobile text-capitalize">
              {roleCategory}
            </span>
          </div>

          <span className="bms-verified-image-icon">
            <Star size={14} fill="#9da3b0" color="#9da3b0" />
          </span>
        </div>

        <Card.Body className="bms-card-body">
          {/* Note: Truncation is handled in CSS now, no .slice() here */}
          <h5 className="bms-project-title">{projectName}</h5>
          <p className="bms-role-name">{roleTitle}</p>
        </Card.Body>
      </Card>
    </Link>
  );
};

export default ModernAuditionCard;